import styled from 'styled-components6';
import { ReviewRating } from '../ReviewRating';
import { ReviewMessage } from './ReviewMessage';
import { ContentSource } from 'rwl-shared/dist/models/ContentSource';
import { mqDown } from '../../theme';

const ReviewContainer = styled.div`
    width: 200px;
    height: 185px;
    padding: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    aspect-ratio: 1;
    flex: 1;
    position: relative;

    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: none;
    transition: 0.4s;
    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(0, 0, 0, 0.25);
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.12);
    }
    border-radius: var(--rwl-radius-sm);

    flex-direction: column;
    justify-content: space-evenly;

    background-color: rgba(255, 255, 255, 0.9);

    ${mqDown('xs')} {
        width: 100%;
    }
`;

const RatingContainer = styled.div`
    width: 100%;
    margin-top: 8px;

    display: flex;
    justify-content: center;
    position: relative;

    align-items: center;
`;

const ReviewInfo = styled.div`
    text-align: center;
    font-weight: normal;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const ReviewName = styled.span`
    letter-spacing: 0.15px;
    margin-left: var(--rwl-spacing-sm);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    font-size: 14px;
    font-weight: normal;
`;

const ReviewMessageContainer = styled.div`
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex: 1;
    vertical-align: center;
`;

export interface ReviewCardReview {
    id: string;
    author?: string;
    rating: number;
    source: ContentSource;
    authorPhotoUrl?: string;
    message: string;
}

const CircleWithInitials = styled.div`
    width: 24px;
    height: 24px;
    background-color: var(--rwl-palette-gray-400);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--rwl-palette-white);
    font-size: 0.75rem;
    font-weight: bold;
    flex-shrink: 0; /* Prevent shrinking when the name is too long */
`;

export interface ReviewCardProps {
    review: ReviewCardReview;
    onCardClick?: (id: string) => void;
}

export const ReviewCard = ({
    review,
    onCardClick = () => void 0,
}: ReviewCardProps): JSX.Element => {
    return (
        <ReviewContainer
            className="rwlReviewContainer"
            id={'review_' + review.id}
            onClick={() => onCardClick(review.id)}
        >
            <RatingContainer>
                <ReviewRating
                    size="small"
                    rating={review.rating}
                    source={review.source}
                />
            </RatingContainer>

            <ReviewMessageContainer>
                <div>
                    <ReviewMessage content={review} />
                </div>
            </ReviewMessageContainer>

            <ReviewInfo>
                {review.author &&
                    (review.authorPhotoUrl ? (
                        <img
                            alt={review.author}
                            height={24}
                            width={24}
                            src={review.authorPhotoUrl}
                            style={
                                review.source === 'Facebook'
                                    ? { borderRadius: '50%' }
                                    : {}
                            }
                        />
                    ) : (
                        <CircleWithInitials>
                            {review.author[0].toLocaleUpperCase()}
                        </CircleWithInitials>
                    ))}
                <ReviewName>{review.author}</ReviewName>
            </ReviewInfo>
        </ReviewContainer>
    );
};
